"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidator = exports.ValidatorName = void 0;
const cpf_1 = require("../cpf/index.js");
const email_1 = require("../email/index.js");
const fullName_1 = require("../fullName/index.js");
const phoneNumber_1 = require("../phoneNumber/index.js");
var ValidatorName;
(function (ValidatorName) {
    ValidatorName["validateFullName"] = "validateFullName";
    ValidatorName["validateCPF"] = "validateCPF";
    ValidatorName["validateEmail"] = "validateEmail";
    ValidatorName["validatePhoneNumber"] = "validatePhoneNumber";
})(ValidatorName = exports.ValidatorName || (exports.ValidatorName = {}));
const validators = {
    [ValidatorName.validateFullName]: fullName_1.validateFullName,
    [ValidatorName.validateCPF]: cpf_1.validateCPF,
    [ValidatorName.validateEmail]: email_1.validateEmail,
    [ValidatorName.validatePhoneNumber]: phoneNumber_1.validatePhoneNumber,
};
const getValidator = (validatorName) => validatorName ? validators[validatorName] : undefined;
exports.getValidator = getValidator;
